import React from "react";
import { Link } from "react-router-dom";
import Tag from "../../../ui-components/molecules/tag/tag";
import { cn } from "../../../services/common/className";
import { AccessorialApprovalStatus, ShipmentWorkItemAccessorial, ShipmentWorkItemReviewStatus } from "../../../app/data/shipment-reconciliation/models";

const getFormattedDate = (date: string) => {
  if (!date) return "";
  return date.toUiDateFormat()
}

const getFormattedReviewStatus = (reviewStatus: ShipmentWorkItemReviewStatus, accessorials: ShipmentWorkItemAccessorial[]) => {
  if (reviewStatus === ShipmentWorkItemReviewStatus.REVIEWED) {
    let reviewedAccessorials: ShipmentWorkItemAccessorial[] = [];
    accessorials.forEach((accessorial: ShipmentWorkItemAccessorial) => {
      if (accessorial && (accessorial.operationApprovalStatus === AccessorialApprovalStatus.ACCEPTED || accessorial.operationApprovalStatus === AccessorialApprovalStatus.RJECTED)) {
        reviewedAccessorials.push(accessorial);
      }
    });
    if (reviewedAccessorials && reviewedAccessorials.length) {
      if (reviewedAccessorials[0].operationApprovalStatus === AccessorialApprovalStatus.ACCEPTED) {
        return <div>
          <Tag mix={cn("cell__review-status")("reviewed")}>
            Accepted
          </Tag> {reviewedAccessorials[0].accessorialDefinition.name}{(reviewedAccessorials.length > 1) ? ` and ${reviewedAccessorials.length - 1} more` : ""}
        </div>
      } else {
        return <div>
          <Tag mix={cn("cell__review-status")("pending")}>
            Rejected
          </Tag> {reviewedAccessorials[0].accessorialDefinition.name}{(reviewedAccessorials.length > 1) ? ` and ${reviewedAccessorials.length - 1} more` : ""}
        </div>
      }
    } else {
      return <Tag mix={cn("cell__review-status")("reviewed")}>
        Reviewed
      </Tag>;
    }
  } else if (reviewStatus === ShipmentWorkItemReviewStatus.PENDING) {
    return <Tag mix={cn("cell__review-status")("pending")}>
      Pending Review
    </Tag>;
  } else {
    return <Tag mix={cn("cell__review-status")("not-required")}>
      Review not required
    </Tag>;
  }
}

const getPendingAccessorialsMessage = (accessorials: ShipmentWorkItemAccessorial[]) => {
  if (!accessorials || !accessorials.length) {
    return <Tag mix={cn("cell__accessorial-message")("no-pending")}>
      No Pending
    </Tag>;
  }
  let pendingAccessorials: ShipmentWorkItemAccessorial[] = [];
  accessorials.forEach((accessorial: ShipmentWorkItemAccessorial) => {
    if (accessorial && accessorial.operationApprovalStatus === AccessorialApprovalStatus.PENDING) {
      pendingAccessorials.push(accessorial);
    }
  });
  if (!pendingAccessorials.length) {
    return <Tag mix={cn("cell__accessorial-message")("no-pending")}>
      No Pending
    </Tag>;
  }
  return <>{pendingAccessorials[0].accessorialDefinition.name}{(pendingAccessorials.length > 1) ? ` and ${pendingAccessorials.length - 1} more` : ""}</>

}

const getFormattedCapatlizedString = (rawString: string) => {
  if (!rawString) return rawString;
  return rawString.split(/[ ,|_]+/).map(ele => `${ele.slice(0, 1).toUpperCase()}${ele.slice(1).toLocaleLowerCase()}`).join(" ");
}

export const getOperationsReviewListColumns = () => [
  {
    header: "Probill",
    id: "probillNumber",
    size: 50,
    cell: (cellProps: any) => (
      <Link
        className="xgs-table-link-cell"
        to={`/shipments/${cellProps.row.original.probillNumber}`}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        {cellProps.row.original.probillNumber}
      </Link>
    )
  },
  {
    header: "Review Status",
    id: "operationsReviewStatus",
    size: 120,
    cell: (cellProps: any) => (
      <>
        {getFormattedReviewStatus(cellProps.row.original.operationsReviewStatus, cellProps.row.original.accessorials)}
      </>
    )
  },
  {
    header: "Pending Accessorials",
    id: "pendingAccessorialCount",
    size: 160,
    cell: (cellProps: any) => (
      <>
        {getPendingAccessorialsMessage(cellProps.row.original.accessorials)}
      </>
    )
  },
  {
    header: "Date Added",
    id: "createdAt",
    size: 50,
    cell: (cellProps: any) => (
      <>
        {getFormattedDate(cellProps.row.original.createdAt)}
      </>
    )
  },
  {
    header: "ETA",
    id: "etaData",
    size: 50,
    cell: (cellProps: any) => (
      <>
        {getFormattedDate(cellProps.row.original.etaData)}
      </>
    )
  },
  {
    header: "Shipper",
    id: "shipperName",
    size: 150,
    cell: (cellProps: any) => (
      <>{getFormattedCapatlizedString(cellProps.row.original.shipperName)} ({cellProps.row.original.shipperNumber})</>
    )
  },
  {
    header: "Consignee",
    id: "consigneeName",
    size: 150,
    cell: (cellProps: any) => (
      <>{getFormattedCapatlizedString(cellProps.row.original.consigneeName)} ({cellProps.row.original.consigneeNumber})</>
    )
  }
];
